module.exports = __webpack_public_path__ + "static/img/portal.b3cf7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portal.png
// module id = oX3U
// module chunks = 3